// Action Options
import ActiveActionIcon from "%/dynamic-component-editor/options/active-action-icon";
import DefaultActionIcon from "%/dynamic-component-editor/options/default-action-icon";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import Prefix from "%/dynamic-component-editor/options/prefix";
import Suffix from "%/dynamic-component-editor/options/suffix";
import StopPropagation from "%/dynamic-component-editor/options/stop-propagation";
import JoinLabel from "%/dynamic-component-editor/options/join-label";
import CallRoomWiring from "%/dynamic-component-editor/options/call-room-wiring";
import StoryComposerWiring from "%/dynamic-component-editor/options/story-composer-wiring";
import FeedAnchorToBottom from "%/dynamic-component-editor/options/feed-anchor-to-bottom";
import FeedLastSeenComponentId from "%/dynamic-component-editor/options/feed-last-seen-component-id";
import FeedRowConditions from "%/dynamic-component-editor/options/feed-row-conditions";

// Background Options
import BackgroundAttachment from "%/dynamic-component-editor/options/background-attachment";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BackgroundImage from "%/dynamic-component-editor/options/background-image";
import BackgroundPosition from "%/dynamic-component-editor/options/background-position";
import BackgroundRepeat from "%/dynamic-component-editor/options/background-repeat";
import BackgroundSize from "%/dynamic-component-editor/options/background-size";
import BackgroundGradient from "%/dynamic-component-editor/options/background-gradient";

// Border Options
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import BorderSides from "%/dynamic-component-editor/options/border-sides";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

// Button Options
import ButtonAction from "%/dynamic-component-editor/options/button-action";
import ButtonSize from "%/dynamic-component-editor/options/button-size";
import ButtonType from "%/dynamic-component-editor/options/button-type";

// Icon Options
import DisplayIcon from "%/dynamic-component-editor/options/display-icon";
import Icon from "%/dynamic-component-editor/options/icon";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import IconSize from "%/dynamic-component-editor/options/icon-size";
import IconVariant from "%/dynamic-component-editor/options/icon-variant";

// Image Options
import FallbackImage from "%/dynamic-component-editor/options/fallback-image";
import ImageAltText from "%/dynamic-component-editor/options/image-alt-text";
import ImageFillBackground from "%/dynamic-component-editor/options/image-fill-background";
import ImageShape from "%/dynamic-component-editor/options/image-shape";
import ObjectFit from "%/dynamic-component-editor/options/object-fit";
import ObjectPosition from "%/dynamic-component-editor/options/object-position";
import SingleImage from "%/dynamic-component-editor/options/single-image";

// Layout Options
import HorizontalLayoutAlign from "%/dynamic-component-editor/options/horizontal-layout-align";
import HorizontalLayoutVerticalAlign from "%/dynamic-component-editor/options/horizontal-layout-vertical-align";
import LayoutDirection from "%/dynamic-component-editor/options/layout-direction";
import StaticLayoutDirection from "%/dynamic-component-editor/options/static-layout-direction";
import LayoutGap from "%/dynamic-component-editor/options/layout-gap";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutWrap from "%/dynamic-component-editor/options/layout-wrap";
import Overflow from "%/dynamic-component-editor/options/overflow";
import Positioning from "%/dynamic-component-editor/options/positioning";
import Rotate from "%/dynamic-component-editor/options/rotate";
import VerticalLayoutAlign from "%/dynamic-component-editor/options/vertical-layout-align";
import VerticalLayoutVerticalAlign from "%/dynamic-component-editor/options/vertical-layout-vertical-align";
import ZIndex from "%/dynamic-component-editor/options/zindex";

// Lock Options
import LockOptions from "%/dynamic-component-editor/options/lock-options";

// Root Options
import ComponentDescription from "%/dynamic-component-editor/options/component-description";
import ComponentName from "%/dynamic-component-editor/options/component-name";
import DisplayName from "%/dynamic-component-editor/options/display-name";
import LockOptionsRoot from "%/dynamic-component-editor/options/root-lock-options";
import OptionVariables from "%/dynamic-component-editor/options/option-variables";
import PageDescription from "%/dynamic-component-editor/options/page-description";
import PageKeywords from "%/dynamic-component-editor/options/page-keywords";
import PageSlug from "%/dynamic-component-editor/options/page-slug";
import PageTitle from "%/dynamic-component-editor/options/page-title";

// Spacing Options
import Margins from "%/dynamic-component-editor/options/margins";
import MaxHeight from "%/dynamic-component-editor/options/max-height";
import MaxWidth from "%/dynamic-component-editor/options/max-width";
import MinHeight from "%/dynamic-component-editor/options/min-height";
import MinWidth from "%/dynamic-component-editor/options/min-width";
import Padding from "%/dynamic-component-editor/options/padding";

// Text Options
import BreakWord from "%/dynamic-component-editor/options/break-word";
import Ellipsis from "%/dynamic-component-editor/options/ellipsis";
import FontCase from "%/dynamic-component-editor/options/font-case";
import FontColor from "%/dynamic-component-editor/options/font-color";
import CountColor from "%/dynamic-component-editor/options/count-color";
import FontFamily from "%/dynamic-component-editor/options/font-family";
import FontSize from "%/dynamic-component-editor/options/font-size";
import CountSize from "%/dynamic-component-editor/options/count-size";
import FontStyle from "%/dynamic-component-editor/options/font-style";
import FontWeight from "%/dynamic-component-editor/options/font-weight";
import LineHeightMultiplier from "%/dynamic-component-editor/options/line-height-multiplier";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import PlaceholderColor from "%/dynamic-component-editor/options/placeholder-color";
import RowTypeField from "%/dynamic-component-editor/options/row-type-field";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import PlaceholderText from "%/dynamic-component-editor/options/placeholder-text";
import RichText from "%/dynamic-component-editor/options/rich-text";
import StyledTextVariant from "%/dynamic-component-editor/options/styled-text-variant";
import TextAlign from "%/dynamic-component-editor/options/text-align";
import TextBrandingStyleOption from "%/dynamic-component-editor/options/text-branding-style-option";
import TextDecoration from "%/dynamic-component-editor/options/text-decoration";
import TextOption from "%/dynamic-component-editor/options/text-option";
import TextStyleOption from "%/dynamic-component-editor/options/text-style-option";
import TextWrap from "%/dynamic-component-editor/options/text-wrap";

// Url options
import HrefOption from "%/dynamic-component-editor/options/href-option";
import Label from "%/dynamic-component-editor/options/label";
import OpenInNewTab from "%/dynamic-component-editor/options/open-in-new-tab";

// Video Options
import Autoplay from "%/dynamic-component-editor/options/autoplay";
import Controls from "%/dynamic-component-editor/options/controls";
import Loop from "%/dynamic-component-editor/options/loop";
import Muted from "%/dynamic-component-editor/options/muted";
import MuteOnAutoplay from "%/dynamic-component-editor/options/mute-on-autoplay";
import Poster from "%/dynamic-component-editor/options/poster";
import SingleVideo from "%/dynamic-component-editor/options/single-video";

// Other Options
import Copyright from "%/dynamic-component-editor/options/copyright";
import DateFormat from "%/dynamic-component-editor/options/date-format";
import EmptyStateText from "%/dynamic-component-editor/options/empty-state-text";
import LayoutCardSize from "%/dynamic-component-editor/options/layout-card-size";
import LinkType from "%/dynamic-component-editor/options/link-type";
import Modal from "%/dynamic-component-editor/options/modal";
import Opacity from "%/dynamic-component-editor/options/opacity";
import StoryEntity from "%/dynamic-component-editor/options/story-entity";
import TabsOption from "%/dynamic-component-editor/options/tabs-option";
import VisibleOption from "%/dynamic-component-editor/options/visible";
import LinkedOptionVariables from "%/dynamic-component-editor/options/linked-option-variables";
import TemplateType from "%/dynamic-component-editor/options/template-type";
import ClickAction from "%/dynamic-component-editor/options/click-action";
import LinkAction from "%/dynamic-component-editor/options/link-action";
import HrefAction from "%/dynamic-component-editor/options/href-action";
import ShowArrows from "%/dynamic-component-editor/options/show-arrows";
import ShowDots from "%/dynamic-component-editor/options/show-dots";
import Snap from "%/dynamic-component-editor/options/snap";
import ItemMinWidth from "%/dynamic-component-editor/options/item-min-width";
import ItemMaxWidth from "%/dynamic-component-editor/options/item-max-width";
import Crop from "%/dynamic-component-editor/options/crop";
import Effects from "%/dynamic-component-editor/options/effects";
import AnimationDuration from "%/dynamic-component-editor/options/animation-duration";
import AnimationDelay from "%/dynamic-component-editor/options/animation-delay";
import AnimationTimingFunction
  from "%/dynamic-component-editor/options/animation-timing-function";
import AnimationIteration from "%/dynamic-component-editor/options/animation-iteration";
import AnimationDirection from "%/dynamic-component-editor/options/animation-direction";
import TextOverflow from "%/dynamic-component-editor/options/text-overflow";
import MaxVerticalLines from "%/dynamic-component-editor/options/max-vertical-lines";
import IconColor from "%/dynamic-component-editor/options/icon-color";
import Blur from "%/dynamic-component-editor/options/blur";
import Brightness from "%/dynamic-component-editor/options/brightness";
import Contrast from "%/dynamic-component-editor/options/contrast";
import Grayscale from "%/dynamic-component-editor/options/grayscale";
import HueRotate from "%/dynamic-component-editor/options/hue-rotate";
import Invert from "%/dynamic-component-editor/options/invert";
import ImageOpacity from "%/dynamic-component-editor/options/image-opacity";
import Saturate from "%/dynamic-component-editor/options/saturate";
import Sepia from "%/dynamic-component-editor/options/sepia";
import BlendMode from "%/dynamic-component-editor/options/blend-mode";
import Rendering from "%/dynamic-component-editor/options/rendering";
import ClipPath from "%/dynamic-component-editor/options/clip-path";
import AutoScroll from "%/dynamic-component-editor/options/auto-scroll";
import ScrollSpeed from "%/dynamic-component-editor/options/scroll-speed";
import InfiniteScroll from "%/dynamic-component-editor/options/infinite-scroll";
import ShowUsername from "%/dynamic-component-editor/options/show-username";
import LayoutAlign from "%/dynamic-component-editor/options/layout-align";
import LayoutAlignVertical from "%/dynamic-component-editor/options/layout-align-vertical";

class OptionsMap {

  static OPTIONS_MAP = {
    // Action Options
    "activeActionIcon": ActiveActionIcon,
    "defaultActionIcon": DefaultActionIcon,
    "displayValue": DisplayValue,
    "prefix": Prefix,
    "suffix": Suffix,
    "stop-propagation": StopPropagation,
    "join-label": JoinLabel,
    "call-room-wiring": CallRoomWiring,
    "story-composer-wiring": StoryComposerWiring,
    "feed-anchor-to-bottom": FeedAnchorToBottom,
    "feed-last-seen-component-id": FeedLastSeenComponentId,
    "feed-row-conditions": FeedRowConditions,

    // Background Options
    "backgroundAttachment": BackgroundAttachment,
    "backgroundColor": BackgroundColor,
    "backgroundImage": BackgroundImage,
    "backgroundPosition": BackgroundPosition,
    "backgroundRepeat": BackgroundRepeat,
    "backgroundSize": BackgroundSize,
    "backgroundGradient": BackgroundGradient,

    // Border Options
    "borderColor": BorderColor,
    "borderRadius": BorderRadius,
    "borderSides": BorderSides,
    "borderWidth": BorderWidth,

    // Button Options
    "buttonAction": ButtonAction,
    "buttonSize": ButtonSize,
    "buttonType": ButtonType,
    "clickAction": ClickAction,

    // Icon Options
    "displayIcon": DisplayIcon,
    "icon": Icon,
    "iconPosition": IconPosition,
    "iconSize": IconSize,
    "iconVariant": IconVariant,
    "iconColor": IconColor,

    // Image Options
    "fallbackImage": FallbackImage,
    "imageAltText": ImageAltText,
    "imageFillBackground": ImageFillBackground,
    "imageShape": ImageShape,
    "objectFit": ObjectFit,
    "objectPosition": ObjectPosition,
    "singleImage": SingleImage,
    "linkAction": LinkAction,
    "crop": Crop,

    // Image Effect Options
    "brightness": Brightness,
    "contrast": Contrast,
    "grayscale": Grayscale,
    "hueRotate": HueRotate,
    "invert": Invert,
    "imageOpacity": ImageOpacity,
    "saturate": Saturate,
    "sepia": Sepia,
    "blendMode": BlendMode,
    "rendering": Rendering,
    "clipPath": ClipPath,


    // Layout Options
    "horizontalLayoutAlign": HorizontalLayoutAlign,
    "horizontalLayoutVerticalAlign": HorizontalLayoutVerticalAlign,
    "layoutAlign": LayoutAlign,
    "layoutAlignVertical": LayoutAlignVertical,
    "layoutDirection": LayoutDirection,
    "staticLayoutDirection": StaticLayoutDirection,
    "layoutGap": LayoutGap,
    "layoutHeight": LayoutHeight,
    "layoutWidth": LayoutWidth,
    "layoutWrap": LayoutWrap,
    "verticalLayoutWrap": LayoutWrap,
    "horizontalLayoutWrap": LayoutWrap,
    "overflow": Overflow,
    "positioning": Positioning,
    "rotate": Rotate,
    "blur": Blur,
    "verticalLayoutAlign": VerticalLayoutAlign,
    "verticalLayoutVerticalAlign": VerticalLayoutVerticalAlign,
    "zIndex": ZIndex,
    "zindex": ZIndex,

    // Lock Options
    "lockOptions": LockOptions,

    // Root Options
    "componentDescription": ComponentDescription,
    "componentName": ComponentName,
    "displayName": DisplayName,
    "lockOptionsRoot": LockOptionsRoot,
    "linkedOptionVariables": LinkedOptionVariables,
    "optionVariables": OptionVariables,
    "pageDescription": PageDescription,
    "pageKeywords": PageKeywords,
    "pageSlug": PageSlug,
    "pageTitle": PageTitle,

    // Spacing Options
    "margins": Margins,
    "maxHeight": MaxHeight,
    "maxWidth": MaxWidth,
    "minHeight": MinHeight,
    "minWidth": MinWidth,
    "padding": Padding,

    // Carousel Options
    "showDots": ShowDots,
    "showArrows": ShowArrows,
    "snap": Snap,
    "itemMinWidth": ItemMinWidth,
    "itemMaxWidth": ItemMaxWidth,
    "autoScroll": AutoScroll,
    "scrollSpeed": ScrollSpeed,
    "infiniteScroll": InfiniteScroll,

    // Text Options
    "maxVerticalLines": MaxVerticalLines,
    "textOverflow": TextOverflow,
    "breakWord": BreakWord,
    "ellipsis": Ellipsis,
    "fontCase": FontCase,
    "fontColor": FontColor,
    "countColor": CountColor,
    "fontFamily": FontFamily,
    "fontSize": FontSize,
    "countSize": CountSize,
    "fontStyle": FontStyle,
    "fontWeight": FontWeight,
    "lineHeightMultiplier": LineHeightMultiplier,
    "lineHeight": LineHeightMultiplier,
    "placeholder": Placeholder,
    "placeholderColor": PlaceholderColor,
    "rowTypeField": RowTypeField,
    "commitAction": CommitAction,
    "placeholderText": PlaceholderText,
    "richText": RichText,
    "styledTextVariant": StyledTextVariant,
    "textAlign": TextAlign,
    "textBrandingStyleOption": TextBrandingStyleOption,
    "textDecoration": TextDecoration,
    "textOption": TextOption,
    "textStyleOption": TextStyleOption,
    "textWrap": TextWrap,

    // Url Options
    "hrefOption": HrefOption,
    "label": Label,
    "openInNewTab": OpenInNewTab,
    "hrefAction": HrefAction,

    // Video Options
    "autoplay": Autoplay,
    "controls": Controls,
    "loop": Loop,
    "muted": Muted,
    "mute-on-autoplay": MuteOnAutoplay,
    "poster": Poster,
    "singleVideo": SingleVideo,

    // Animation Options
    "animationDuration": AnimationDuration,
    "animationDelay": AnimationDelay,
    "animationTimingFunction": AnimationTimingFunction,
    "animationIteration": AnimationIteration,
    "animationDirection": AnimationDirection,

    // Other Options
    "copyright": Copyright,
    "dateFormat": DateFormat,
    "effects": Effects,
    "emptyStateText": EmptyStateText,
    "layoutCardSize": LayoutCardSize,
    "linkType": LinkType,
    "modal": Modal,
    "opacity": Opacity,
    "storyEntity": StoryEntity,
    "tabsOption": TabsOption,
    "visible": VisibleOption,
    "showUsername": ShowUsername,
    "templateType": TemplateType,
  };

  static get optionsMap() {
    return this.OPTIONS_MAP;
  }

  static setOptions(options) {
    this.OPTIONS_MAP = {
      ...this.OPTIONS_MAP,
      ...options,
    };
  }

  static deprecatedOptionKeys = [
    "background",
    "line-height",
    "ellipsis",
    "break-word",
  ];
}

export default OptionsMap;
